import "../../assets/css/carousel.scss";
import "../../assets/css/grid.scss";
import "../../assets/css/style.scss";
import Header from "../layout/Header";
import Carousel from "../common/Carousel";
import Giveaways from "../common/Giveaways";
import Faq from "../common/Faq";
import Footer from "../layout/Footer";
import PlansListStatic from "../common/PlansListStatic";

function HomePage() {
  return (
    <div className="App">
      <Header />
      <Carousel />
      <Giveaways />
      <Faq theme="dark" />
      <PlansListStatic showHero={false} showTrustStrip={false} />
      <Footer />
    </div>
  );
}

export default HomePage;
